












import { Component, Prop, Vue } from 'vue-property-decorator';
import CheckoutContractDurationItem from './CheckoutContractDurationItem.vue';
import { ProductServerDuration } from '../../../store/product/types';

@Component({
  components: { CheckoutContractDurationItem },
})
export default class CheckoutContractDurationList extends Vue {
  name = 'CheckoutContractDurationList';

  selectedContractDurationId: number = undefined;

  @Prop({ type: Array, required: true }) readonly contractDurations: Array<ProductServerDuration>;

  @Prop({ type: Object, required: false }) readonly selectedContractDuration: ProductServerDuration;

  contractSelect(duration: ProductServerDuration) {
    this.$emit('contract-select', duration);
  }
}
